/* eslint-disable */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const nameItemText = "Lente de Contacto";
//
// ########################################################################### 
//
const ValorLenteContactoDialog = ({
  onClose,
  rangoData,
}) => {
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Ver {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionProveedor"
                label="Proveedor"
                variant="outlined"
                size="small"
                name="descripcionProveedor"
                value={rangoData.descripcionProveedor}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionLenteContactoProducto"
                label="Producto"
                variant="outlined"
                size="small"
                name="descripcionLenteContactoProducto"
                value={rangoData.descripcionLenteContactoProducto}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionLcPresentacion"
                label="Presentación"
                variant="outlined"
                size="small"
                name="descripcionLcPresentacion"
                value={rangoData.descripcionLcPresentacion}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="curvasList"
                label="Curva"
                variant="outlined"
                size="small"
                name="curvasList"
                value={rangoData.curvasList}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="diametrosList"
                label="Diámetro"
                variant="outlined"
                size="small"
                name="diametrosList"
                value={rangoData.diametrosList}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="esferaDesde"
                label="Esfera Desde"
                variant="outlined"
                size="small"
                name="esferaDesde"
                value={rangoData.esferaDesde}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="esferaHasta"
                label="Esfera Hasta"
                variant="outlined"
                size="small"
                name="esferaHasta"
                value={rangoData.esferaHasta}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="cilindroDesde"
                label="Cilindro Desde"
                variant="outlined"
                size="small"
                name="cilindroDesde"
                value={rangoData.cilindroDesde}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="cilindroHasta"
                label="Cilindro Hasta"
                variant="outlined"
                size="small"
                name="cilindroHasta"
                value={rangoData.cilindroHasta}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="costoPesos"
                label="Costo en $"
                variant="outlined"
                size="small"
                name="costoPesos"
                value={rangoData.costoPesos}
                disabled={true}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="valorDolar"
                label="Valor U$S"
                variant="outlined"
                size="small"
                name="valorDolar"
                value={rangoData.valorDolar}
                disabled={true}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="costoDolares"
                label="Costo en U$S"
                variant="outlined"
                size="small"
                name="costoDolares"
                value={rangoData.costoDolares}
                disabled={true}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="porcentajeDescuento"
                label="% Descuento"
                variant="outlined"
                size="small"
                name="porcentajeDescuento"
                value={rangoData.porcentajeDescuento}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="costoReal"
                label="Costo Real"
                variant="outlined"
                size="small"
                name="costoReal"
                value={rangoData.costoReal}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="precioVentaContado"
                label="PV Contado $"
                variant="outlined"
                size="small"
                name="precioVentaContado"
                value={rangoData.precioVentaContado}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futContado"
                label="Factor Utilidad Contado"
                variant="outlined"
                size="small"
                name="futContado"
                value={rangoData.futLista}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="precioVentaLista"
                label="PV Lista $"
                variant="outlined"
                size="small"
                name="precioVentaLista"
                value={rangoData.precioVentaLista}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futLista"
                label="Factor Utilidad Lista"
                variant="outlined"
                size="small"
                name="futLista"
                value={rangoData.futLista}
                disabled={true}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ mr: 2 }}
            variant="outlined"
            size="small"
            onClick={handleCloseDialog}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ValorLenteContactoDialog;
